module.exports = __webpack_public_path__ + "img/arrow-down.9b9ac3cc.svg";